/**
 * Client helpers for the no-login preview flow. Pure functions — does
 * not import anywhere else in the app's auth/billing surface area.
 */
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "cre_anonymous_trial_id";

function _uuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  // RFC4122-ish fallback
  return "preview-" + Math.random().toString(36).slice(2) + "-" + Date.now();
}

export function getOrCreateAnonymousTrialId() {
  try {
    let id = window.localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = _uuid();
      window.localStorage.setItem(STORAGE_KEY, id);
    }
    // Also drop a non-HttpOnly cookie hint — the server's authoritative
    // anti-tamper cookie is signed and HttpOnly, set by /preview/analyze.
    document.cookie = `${STORAGE_KEY}=${encodeURIComponent(id)}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
    return id;
  } catch {
    return _uuid();
  }
}

const client = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

export async function fetchPreviewQuota(trialId) {
  const r = await client.get("/preview/quota", {
    params: { anonymous_trial_id: trialId },
  });
  return r.data;
}

export async function startPreviewSession(trialId) {
  const r = await client.post("/preview/start", { anonymous_trial_id: trialId });
  return r.data;
}

export async function runPreviewAnalysis(trialId, incident) {
  const r = await client.post("/preview/analyze", {
    anonymous_trial_id: trialId,
    ...incident,
  });
  return r.data;
}

export async function fetchPreviewIncident(trialId, incidentId) {
  const r = await client.get(`/preview/incidents/${incidentId}`, {
    params: { anonymous_trial_id: trialId },
  });
  return r.data;
}
